module.exports = __webpack_public_path__ + "static/media/banner1.beb25a59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Almi/images/banner1.jpg
// module id = 500
// module chunks = 0